<template>
  <div class="listWrapper">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ListWrapper"
};
</script>

<style lang="scss">
.listWrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: inherit;
  overflow: auto;
  align-items: center;
  justify-content: center;
}
</style>
